import Notify from "config/notify";
import apiClient from "../../../config/apiClient";

const API_LIST_URL = `${process.env.REACT_APP_API_URL}/mst/client/select`;
const API_UPDATE_URL = `${process.env.REACT_APP_API_URL}/mst/client/update`;

/**
 * Handles errors by logging them or sending them to an error tracking service.
 * @param {string} message - The error message.
 * @param {any} error - The error object.
 */
const handleError = (message: string, error: any) => {
  // Replace this with your error handling logic
  console.error(message, error);
};

/**
 * Fetches the list of clients from the API.
 * @param {any} data - The data to fetch the clients.
 * @returns {Promise<any>} The data from the API response.
 * @throws Will throw an error if the request fails.
 */
const fetchClientsApi = async (data: any): Promise<any> => {
  try {
    const response = await apiClient.post(`${API_LIST_URL}`, data);
    return response.data;
  } catch (error) {
    handleError("Error fetching clients:", error);
    throw error;
  }
};

/**
 * Updates a client using the API.
 * @param {any} data - The data to update the client.
 * @returns {Promise<any>} The data from the API response.
 * @throws Will throw an error if the request fails.
 */
const updateClientApi = async (data: any): Promise<any> => {
  try {
    const response = await apiClient.post(`${API_UPDATE_URL}`, data);
    if (response.status === 200) {
      Notify.setNotification({
        show: true,
        title: data.delete_flag ? "削除しました" : "更新が完了しました",
        confirmLabel: "OK",
        actionsPosition: "center",
      });
      return response.data;
    }
    throw new Error("Error updating client");
  } catch (error) {
    handleError("Error updating client:", error);
    throw error;
  }
};

export { fetchClientsApi, updateClientApi };
